import React, { useState, useEffect } from "react";
import Select from "react-select";
import styles from "assets/scss/task_management.module.css";
import { Control, LocalForm } from 'react-redux-form';
import { Button, Col, Row, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { FormGroup } from "components/common";
import { Trans } from "react-i18next";

const UpdateLabel = ({ label, onClose, onSave }) => {
    const [labelName, setLabelName] = useState("");
    const [selectedColor, setSelectedColor] = useState(null);

    useEffect(() => {
        if (label) {
            setLabelName(label.label_name);
            const color = colorOptions.find(option => option.color === label.color_code);
            setSelectedColor(color);
        } else {
            setLabelName("");
            setSelectedColor(null);
        }
    }, [label]);

    const colorMap = {
        'Green': '#77DD77',
        'Yellow': '#FFFF00',
        'Pastel Yellow': '#FDFD96',
        'Dark Green': '#008000',//'#006400',
        'Red': '#FF0000',
        'Pastel Red': '#FF6961',
        'Pastel Aqua': '#99C5C4',
        'Pastel Mint': '#B2F9FC',
        'Pastel Coral': '#FF9AA2',
        'Pastel Lilac': '#D4A5A5',
        'Pastel Beige': '#F5F5DC',
        'Pastel Purple ': '#CBAACB',
        'Blue': '#0000FF',
        'Orange': '#FFA500',
        'Purple': '#800080',
        'Pink': '#FFC0CB',
        'Brown': '#A52A2A',
        'Black': '#000000',
        'White': '#FFFFFF',
        'Gray': '#808080',
        'Pastel Turquoise': '#AFEEEE',
        'Pastel Cyan': '#B2EBF2',
        'Cyan': '#00FFFF',
        'Magenta': '#FF00FF',
        'Lime': '#00FF00',
        'Maroon': '#800000',
        'Navy': '#000080',
        'Olive': '#808000',
        'Teal': '#008080',
        'Silver': '#C0C0C0',
        'Gold': '#FFD700',
        'Indigo': '#4B0082',
        'Violet': '#EE82EE',
        'Turquoise': '#40E0D0',
        'Lavender': '#E6E6FA',
        'Beige': '#F5F5DC',
        'Coral': '#FF7F50',
        'Salmon': '#FA8072',
        'Chocolate': '#D2691E',
        'Crimson': '#DC143C',
        'Pastel Peach': '#FFDAB9',
    };

    const colorOptions = Object.keys(colorMap).map(label => ({
        value: label,
        label: label,
        color: colorMap[label]
    }));

    const handleSave = () => {
        const colorCode = selectedColor ? selectedColor.color : label.color_code;
        const updatedLabel = { 
            ...label,
            label_name: labelName,
            color_code: colorCode,
        };

        onSave(updatedLabel);
        onClose();
    };

    const handleChange = (e) => {
        setLabelName(e.target.value);
    };

    return (
        <Modal isOpen={!!label} toggle={onClose}>
            <ModalHeader toggle={onClose}><Trans>Edit Label</Trans></ModalHeader>
            <ModalBody>
                <LocalForm>
                    <div className={styles.modalContent}>
                        <Row>
                            <Col md={12}>
                                <FormGroup label="Label Name">
                                    <Control.text
                                        model=".label_name"
                                        className="form-control"
                                        id="labelName"
                                        style={{ backgroundColor: '#F4F7FE' }}
                                        onChange={handleChange}
                                        value={labelName}
                                        placeholder="Label name"
                                        required
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <label><Trans>Label color</Trans>*</label>
                                <Select 
                                    options={colorOptions} 
                                    value={selectedColor} 
                                    onChange={setSelectedColor}
                                />
                            </Col>
                        </Row>
                    </div>
                </LocalForm>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={onClose}><Trans>Cancel</Trans></Button>
                <Button color="primary" type="submit" onClick={handleSave}><Trans>Save</Trans></Button>
            </ModalFooter>
        </Modal>
    );
};

export default UpdateLabel;
